module.exports = __webpack_public_path__ + "static/team-member-desktop-585a20c39a4dcbb7aec1a4bad67be633.jpg";